import axios from "axios";
import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';
import { prepareFormDataForImageUpload } from '../../imageUploadQuality';

export const v4_mailbox_folders = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/folders/${id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_emails = async (page = 1, limit = 10, folder = 'INBOX', selectedMailboxId, search = '') => {
    const query = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        folder: folder || 'INBOX',
        id: String(selectedMailboxId || '')
    });

    const normalizedSearch = (search || '').trim();
    if (normalizedSearch) {
        query.set('search', normalizedSearch);
    }

    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/emails?${query.toString()}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_email = async (messageId, folder = 'INBOX', selectedMailboxId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/email?messageId=${encodeURIComponent(messageId)}&folder=${encodeURIComponent(folder)}&id=${selectedMailboxId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_attachments = async (messageId, folder = 'INBOX', selectedMailboxId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/attachments?messageId=${encodeURIComponent(messageId)}&folder=${encodeURIComponent(folder)}&id=${selectedMailboxId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_attachment_content = async (messageId, attachmentId, folder = 'INBOX', selectedMailboxId) => {
    const query = new URLSearchParams({
        messageId: String(messageId || ''),
        attachmentId: String(attachmentId || ''),
        folder: String(folder || 'INBOX'),
        id: String(selectedMailboxId || '')
    });

    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/attachment/content?${query.toString()}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_configure = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/configure`;
    return customAxios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v4_microsoft_mailbox_configure = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/auth/microsoft/callback`;
    return customAxios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_configuration = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/configure`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v4_crew_mailbox_configure = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/crew/configure`;
    return customAxios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_crew_mailbox_configuration = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/crew/configure`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_crew_mailbox_remove = async (shipId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/crew/configure/${shipId}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_crew_mailbox_activity = async (shipId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/crew/activity/${shipId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_logout = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/configure/${id}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v4_mailbox_compose = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/compose`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v4_mailbox_handleMailAction = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/handleMailAction`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_chat_message_send = async (to, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/chat/${to}`;
    const payload = await prepareFormDataForImageUpload(model);
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_chat_message_fetch = async (receiver_id, limit = 100) => {
    const safeLimit = Number(limit) > 0 ? Number(limit) : 100;
    const url = `${process.env.REACT_APP_BASE_URL}/v4/chat/${receiver_id}?limit=${safeLimit}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_chat_incoming = async (afterMessageId = 0, limit = 25) => {
    const safeAfterMessageId = Number(afterMessageId);
    const safeLimit = Number(limit) > 0 ? Math.min(Number(limit), 100) : 25;
    const query = new URLSearchParams({ limit: String(safeLimit) });

    if (Number.isInteger(safeAfterMessageId) && safeAfterMessageId > 0) {
        query.set('afterMessageId', String(safeAfterMessageId));
    }

    const url = `${process.env.REACT_APP_BASE_URL}/v4/chat/incoming?${query.toString()}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/comment`;
    const payload = await prepareFormDataForImageUpload(model);
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_fetch_mailbox_comment = async (messageId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/comment/${messageId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v4_fetch_mailbox_activity = async (messageId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/activity/${messageId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v4_mailbox_tag = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/tag`;
    const payload = await prepareFormDataForImageUpload(model);
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_fetch_mailbox_tag = async (messageId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/tag/${messageId}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_mailbox_remove_tag = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/tag`;
    return axios.delete(url, {
        ...getAuthHeader(),
        data: model,
    }).then((res) => {
        return res.data;
    })
}


export const v4_fetch_mailbox_recipients = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/recipients`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v4_add_mailbox_recipients = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/recipients`;
    const payload = await prepareFormDataForImageUpload(model);
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_delete_mailbox_recipient = async (id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/mailBox/recipients/${id}`;
    return axios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
